import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SearchPage from './pages/SearchPage';
import JourneyPage from './pages/JourneyPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<SearchPage />} />
        <Route path="/status/:trackingNumber" element={<JourneyPage />} />
      </Routes>
    </div>
  );
}

export default App;